<template>
	<v-tooltip top>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				fab
				small
				dark
				color="indigo"
				class="mr-2"
				v-bind="attrs"
				v-on="on"
				@click.prevent="onClick"
			>
				<v-icon dark>
					edit
				</v-icon>
			</v-btn>
		</template>
		<span>עריכה</span>
	</v-tooltip>
</template>

<script>
export default {
	name: "EditBtn",
	components: {},
	props: ["data"],
	data () {
		return {};
	},
	computed: {},
	watch: {},
	created () {
	},
	mounted () {
	},
	updated () {
	},
	destroyed () {
	},
	methods: {
		onClick () {
			this.$emit("click", this.data);
		},
	},
};
</script>

<style scoped>

</style>
